export function loadMorePosts(postType = '', callback = null, filters = {}, receivedCount = 0) {
	const requestData = {
		action: Object.keys(filters).length === 0 ? 'getNewCarts' : 'getFilteredCarts',
		receivedCount: receivedCount,
		postType: postType,
		filters: JSON.stringify(filters), // Серіалізуємо об'єкт у рядок
	};


	fetch(params.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		body: new URLSearchParams(requestData).toString()
	})
	.then(response => {
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		return response.json();
	})
	.then(data => {
		callback(data);
	})
	.catch(error => {
		console.error('Error:', error); // Обробка помилок
	});
}